import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchTaskList} from 'sr/utils/api/fetchTaskList'
export const fetchTaskData = createAsyncThunk(
  'task/fetchTaskData',
  async (payload: any) => {
    // Single call instead of double-fetch pattern
    const response = await fetchTaskList({...payload, limit: 10000})
    const data: {task_name: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((task: any) => {
      idNameMap[task.id || task._id] = task.name
      data.push({
        task_name: task.name,
        id: task.id || task._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { task } = getState() as { task: { status: string } }
      return task.status !== 'succeeded' && task.status !== 'loading'
    },
  }
)
